/**
 * 区域模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取区域列表
export const provincesList = (params) => {
  return req.get('/system/provinces/list', params);
}

// 获取区域列表树结构
export const provincesTree = (params) => {
  return req.get('/system/provinces/tree', params);
}

// 新增区域
export const provincesAdd = (params) => {
  return req.post('/system/provinces', params);
}

// 删除区域
export const provincesDelete = (provincesIds) => {
  return req.delete(`/system/provinces/${provincesIds}`);
}

// 批量新增区域
export const provincesListAdd = (params) => {
  return req.post('/system/provinces/batch', params);
}

// 修改区域
export const provincesEdit = (params) => {
  return req.put('/system/provinces', params);
}

// 获取区域子列表
export const provincesSubList = (provincesId) => {
  return req.get(`/system/provinces/subsetList/${provincesId}`);
}